var _mask, _path, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTimeAtack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _mask || (_mask = /*#__PURE__*/React.createElement("mask", {
    id: "path-1-inside-1_4071_7992",
    fill: "white"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9 4.75982 9 4.63973 9.08331 4.5652C9.16662 4.49067 9.27741 4.50303 9.49898 4.52775C10.1143 4.5964 10.7107 4.79153 11.25 5.10289C11.9341 5.49784 12.5022 6.06591 12.8971 6.75C13.2921 7.43409 13.5 8.21009 13.5 9C13.5 9.78992 13.2921 10.5659 12.8971 11.25C12.5022 11.9341 11.9341 12.5022 11.25 12.8971C10.5659 13.2921 9.78991 13.5 9 13.5C8.21008 13.5 7.43409 13.2921 6.75 12.8971C6.21071 12.5858 5.74352 12.1668 5.37641 11.6683C5.24421 11.4887 5.17811 11.399 5.20101 11.2895C5.2239 11.1801 5.3279 11.1201 5.5359 11L8.75 9.14434C8.87201 9.0739 8.93301 9.03868 8.96651 8.98066C9 8.92265 9 8.85221 9 8.71132V5Z"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9 5C9 4.75982 9 4.63973 9.08331 4.5652C9.16662 4.49067 9.27741 4.50303 9.49898 4.52775C10.1143 4.5964 10.7107 4.79153 11.25 5.10289C11.9341 5.49784 12.5022 6.06591 12.8971 6.75C13.2921 7.43409 13.5 8.21009 13.5 9C13.5 9.78992 13.2921 10.5659 12.8971 11.25C12.5022 11.9341 11.9341 12.5022 11.25 12.8971C10.5659 13.2921 9.78991 13.5 9 13.5C8.21008 13.5 7.43409 13.2921 6.75 12.8971C6.21071 12.5858 5.74352 12.1668 5.37641 11.6683C5.24421 11.4887 5.17811 11.399 5.20101 11.2895C5.2239 11.1801 5.3279 11.1201 5.5359 11L8.75 9.14434C8.87201 9.0739 8.93301 9.03868 8.96651 8.98066C9 8.92265 9 8.85221 9 8.71132V5Z",
    fill: "#3C2E21",
    stroke: "#3C2E21",
    strokeWidth: 2.4,
    mask: "url(#path-1-inside-1_4071_7992)"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 6.15,
    stroke: "#3C2E21",
    strokeWidth: 1.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeAtack);
export default __webpack_public_path__ + "static/media/time-atack.b627c080d27e2ee32f2b81b75aa6552e.svg";
export { ForwardRef as ReactComponent };